module.exports = __webpack_public_path__ + "img/cvform2.5e9a9ea9.webp";